<ion-app>
	<router-outlet></router-outlet>
	<qo-log-content></qo-log-content>
</ion-app>

